<template>
  <div class="landing" id="app">
    <CommonMenu />
    <RegionInfoOverlay
      v-if="showRegionInfoOverlay"
      @close="showRegionInfoOverlay = false"
    />
    <div class="landing_content" :key="currentCountry">
      <Transition name="page-transition" mode="out-in" appear>
        <RouterView />
      </Transition>
      <Spinner class="app-spinner" size="large" color="red" v-if="showSpinner" />
    </div>
    <PageFooter />
    <PortalTarget name="overlay" slim />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import CommonMenu from '@/common/common-menu/CommonMenu'
import Spinner from '@/common/components/Spinner'
import ErrorBoundary from '@/common/components/ErrorBoundary'
import RegionInfoOverlay from '@/components/RegionSelect/RegionInfoOverlay'
import PageFooter from '@/components/PageFooter/PageFooter'

import { AVAILABLE_COUNTRIES } from '@/constants'

@Component({
  components: {
    PageFooter,
    RegionInfoOverlay,
    Spinner,
    CommonMenu,
    ErrorBoundary
  }
})
class LandingApp extends Vue {
  @State('country') currentCountry
  @Action('auth/authenticate') authenticateUser
  @Getter('auth/userID') userID

  showRegionInfoOverlay = false

  get showSpinner () {
    return this.isLoading && Boolean(this.currentCountry)
  }

  async fetchAuth () {
    await this.authenticateUser(true)
    this.$analytics.sendUserAnalytics({ userID: this.userID })
  }

  created () {
    this.fetchAuth()
    if (!this.currentCountry || !AVAILABLE_COUNTRIES[this.currentCountry]) {
      this.showRegionInfoOverlay = true
    }
  }
}

export default LandingApp
</script>

<style lang="scss">
@import "@/common/assets/scss/common/common.scss";

.landing {
  /*display: grid;*/
  /*grid-template-columns: auto;*/
  /*grid-template-rows: auto 1fr auto;*/
  display: flex;
  flex-direction: column;
  min-height: 100%;
  &_content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  position: relative;

  &_content {
    flex-grow: 1;
    overflow: hidden;
    padding-top: $menu_height;
    @include media_tablet {
      padding-top: $menu_height_tablet;
    }
  }
}

.landing-transition {
  &-enter-active, &-leave-active {
    transition: all .3s ease-in-out;
  }

  &-enter, &-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
}

.app-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
</style>
